import { render, staticRenderFns } from "./app-link.vue?vue&type=template&id=20b731e5&scoped=true"
import script from "./app-link.vue?vue&type=script&lang=js"
export * from "./app-link.vue?vue&type=script&lang=js"
import style0 from "./app-link.vue?vue&type=style&index=0&id=20b731e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b731e5",
  null
  
)

export default component.exports